import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// Vue.use(store);
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-215568487-1" },
});

import VuePapaParse from "vue-papa-parse";
import VueGlide from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
Vue.use(VueGlide);

Vue.config.productionTip = false;
Vue.use(VuePapaParse);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
